import styled from "styled-components"
import {
  desktopTextStyles,
  tabletTextStyles,
  mobileTextStyles,
} from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"

export const ContentWrapper = styled.div`
  background-color: var(--light-background);
  padding-top: 48px;
  padding-bottom: 48px;
  text-align: center;

  @media (min-width: ${Breakpoints.md}) {
    padding-top: 64px;
    padding-bottom: 64px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    padding-top: 96px;
    padding-bottom: 96px;
  }
`
export const Title = styled.h3`
  grid-column: 2 / -2;
  text-align: center;
  ${mobileTextStyles.MobileHeadingTwoBold}
  width: 100%;
  color: var(--slate);

  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletHeadingTwoSemiBold}
    padding-bottom: 24px;
    border-bottom: 1px solid #2e2e2e33;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingTwoSemiBold}
    grid-column: 4 / -4;
    padding-bottom: 32px;
  }
`

export const PerksWrapper = styled.div`
  display: none;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 1 / -1;
    display: grid;
    flex-wrap: wrap;
    grid-template-columns: 1fr 1fr;
    grid-gap: 16px;
    grid-row-gap: 48px;
    margin-top: 48px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / -2;
    grid-gap: 96px;
    grid-row-gap: 96px;
  }
`

export const PerksCardSliderWrapper = styled.div`
  overflow: hidden;
  grid-column: 1 / -1;
  margin-top: 48px;
  padding-bottom: 48px;
  & .slick-prev {
    transform: translate3d(20px, 0, 0);
  }
  & .slick-next {
    transform: translate3d(-20px, 0, 0);
  }

  .slick-dots {
    bottom: -32px;
  }
`
